// =====================================================================================
// INVRT Radar - web console - membership list helpers
//
// Shared, non-component logic for the membership rows SessionProvider reads from
// `memberships` (the only source of org scope).
// =====================================================================================

import type { Membership } from "@/lib/types";

/**
 * One option per organisation, never two: a duplicated membership row for the same org id
 * (a data defect upstream, or a join returning two rows) must not render as a second
 * organisation in the switcher, because choosing it feels like a switch that does
 * nothing. Keeps the first occurrence, preserving the query's org_id order.
 */
export function dedupeMembershipsByOrgId(rows: Membership[]): Membership[] {
  const seen = new Set<string>();
  const unique: Membership[] = [];
  for (const row of rows) {
    if (seen.has(row.org_id)) continue;
    seen.add(row.org_id);
    unique.push(row);
  }
  return unique;
}
